import { render, staticRenderFns } from "./DeleteQuestion.vue?vue&type=template&id=13343e34&scoped=true&"
import script from "./DeleteQuestion.vue?vue&type=script&lang=ts&"
export * from "./DeleteQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=13343e34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13343e34",
  null
  
)

export default component.exports